import React, { useRef, useState, PropsWithChildren, useEffect } from 'react';
import { CommentContext, CommentContextProps } from './comment.context';

import type { Comment } from '../../../app/entities/comment';

type CommentProviderType = {
  comments: CommentContextProps['comments'];
};

export const CommentProvider: React.FC<PropsWithChildren<CommentProviderType>> = ({
  children,
  comments: baseComments,
}) => {
  const commentsListRef = useRef<HTMLDivElement>(null);
  const playerRef = useRef<HTMLVideoElement | null>(null);

  const [selectedComment, setSelectedComment] = useState<Comment>();
  const [comments, setComments] = useState<Comment[]>(baseComments);
  const [pdfCurrentPage, setPdfCurrentPage] = useState<number>(0);

  useEffect(() => {
    setComments(baseComments);
  }, [baseComments]);

  const selectComment = (comment?: Comment) => {
    if (!comment) {
      setSelectedComment(undefined);
      return;
    }

    setSelectedComment(comment);

    if (!commentsListRef?.current) {
      return;
    }

    const element = (Array.from(commentsListRef.current.children) as HTMLDivElement[]).find(
      (el) => el.id === comment._id,
    );

    if (!element) {
      return false;
    }

    commentsListRef.current.scrollTop = element.offsetTop - commentsListRef.current.offsetTop;
  };

  const addComment = (comment: Comment) => {
    const finalComments = comments.concat(comment);

    setComments(finalComments);
  };

  const deleteComment = async (id: string) => {
    const finalComments = comments.filter((comment) => comment._id !== id);

    setComments(finalComments);
  };

  const updateComment = async (comment: Comment) => {
    const finalComments = [...comments];
    const targetCommentIndex = finalComments.findIndex((el) => el._id === comment._id);
    finalComments[targetCommentIndex] = comment;

    setComments(finalComments);
  };

  return (
    <CommentContext.Provider
      value={{
        comments,
        selectComment,
        selectedComment: selectedComment,
        addComment,
        deleteComment,
        updateComment,
        commentsListRef,
        playerRef,
        pdfCurrentPage,
        setPdfCurrentPage,
      }}
    >
      {children}
    </CommentContext.Provider>
  );
};
